import { useState, useContext } from "react";
import { Container, Card, Form, Button, Alert } from "react-bootstrap";
import userContext from "./Context";
import "./Withdraw.css";

function Withdraw() {

  const [value, setValue] = useState("");
  const [message, setMessage] = useState("");
  const { total, setTotal } = useContext(userContext);

  function remove(e) {
    e.preventDefault();

    const amount = Number(value);

    if (!value || amount <= 0) {
      setMessage("Please enter a valid amount");
      return;
    }

    if (amount > total) {
      setMessage("Insufficient Balance ❌");
      return;
    }

    setTotal(total - amount);
    setMessage("Amount Withdrawn Successfully ✅");
    setValue("");
  }

  return (
    <div className="withdraw-bg">
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <Card className="withdraw-card shadow-lg p-4">
          <h2 className="text-center mb-4 Danger">Withdraw Amount</h2>

          <Form onSubmit={remove}>
            <Form.Group className="mb-3">
              <Form.Label>Enter Amount</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter amount"
                value={value}
                onChange={(e) => setValue(e.target.value)}
              />
            </Form.Group>

            <Button variant="primary" type="submit" className="w-100 withdraw-btn">
              Withdraw
            </Button>
          </Form>

          {message && (
            <Alert variant="success" className="mt-3 text-center">
              {message}
            </Alert>
          )}

          <h4 className="text-center mt-4 total-text">
            Total Balance: ₹ {total}
          </h4>
        </Card>
      </Container>
    </div>
  );
}

export default Withdraw;
